'use strict';

const {map} = require('lodash/collection'),
    {t} = require('services/i18nextWrapper'),
    {merge} = require('lodash/object'),
    get = require('lodash/object').get,
    {union} = require('lodash/array');

const ComponentUtils = {

    /**
     * Given items data text, retrieve the custom structure of dropdown menu to use given data.
     */
    toMenuItemsText(items, nonSelectText, locatorPrefix) {
        const menuItem = [{payload: 0, text: nonSelectText}];
        return union(menuItem, map(items, function (item, index) {
            return {
                payload: index + 1,
                text: item,
                itemModel: item, // to be consistence which `toMenuItems` method
                index: index,
                locatorId: locatorPrefix ? locatorPrefix + index : index
            };
        }));
    },

    /**
     * Given items data object, retrieve the custom structure of dropdown menu to use given data..
     */
    toMenuItems(items, textAttr = 'name', iconAttr = 'icon', locatorPrefix, extraArguments) {
        return map(items, function (item, index) {
            return merge({
                payload: index + 1,
                text: textAttr ? typeof item === 'string' ? item : get(item, textAttr) : item,
                itemModel: item,
                iconClassName: get(item, iconAttr, ''),
                locatorId: locatorPrefix ? locatorPrefix + index : index
            }, extraArguments);
        });
    },

    /**
     * Given items data object, retrieve the custom structure of dropdown menu to use given data..
     */
    toMenuItemsWithNonSelectedItem(
      items,
      nonSelectText = t('component_utils_selected_item'),
      textAttr = 'name'
    ) {
        const nonSelectedItem = [{payload: 0, text: nonSelectText}];
        return union(nonSelectedItem, map(items, function (item, index) {
            return {
                payload: index + 1,
                text: textAttr ? typeof item === 'string' ? item : get(item, textAttr || 'icon') : item,
                itemModel: item
            };
        }));
    }

};

module.exports = ComponentUtils;



/** WEBPACK FOOTER **
 ** ./src/utils/ComponentUtils.js
 **/